export default function CommentCount({appDotLinkUrl, count}) {
  let text = 'Be the first to comment!';
  if (count === 1) {
    text = 'See 1 comment';
  } else if (count > 1) {
    text = `See all ${count} comments`;
  }
  return (
    <p className="userpostpage__commentCount">
      <a href={appDotLinkUrl}>{text}</a>
    </p>
  );
}
